
export default class AddressParser {
    constructor(results) {
        this.results = results
    }
    loopAndSearchForAddressComponentType(type) {
        let resultCount = this.results.length
        for (let resultIndex = 0; resultIndex < resultCount; resultIndex++) {
            let result = this.results[resultIndex]

            let addressComponents = result.address_components
            if (!addressComponents || !Array.isArray(addressComponents)) {
                continue
            }

            let addressComponentCount = addressComponents.length
            for (let addressComponentIndex = 0; addressComponentIndex < addressComponentCount; addressComponentIndex++) {
                let addressComponent = addressComponents[addressComponentIndex]
                let types = addressComponent.types
                if (!types || !Array.isArray(types)) {
                    continue
                }
                if (types.indexOf(type) !== -1) {
                    // Found first street number
                    return addressComponent.long_name
                }
            }
        }
    }
    getStreetNumber() {
        return this.loopAndSearchForAddressComponentType('street_number')
    }
    getRoute() {
        return this.loopAndSearchForAddressComponentType('route')
    }
    getSublocality() {
        return this.loopAndSearchForAddressComponentType('sublocality')
    }
    getLocality() {
        return this.loopAndSearchForAddressComponentType('locality')
    }
    getAdministrativeAreaLevel_1() {
        return this.loopAndSearchForAddressComponentType('administrative_area_level_1')
    }
    getPostalCode() {
        return this.loopAndSearchForAddressComponentType('postal_code')
    }
}